export const ADMIN_PANEL_SERVER_URL =
  process.env.REACT_APP_ADMIN_PANEL_SERVER_URL || 'https://localhost:8443';
export const SOCIAL_AUTH_SERVER_URL =
  process.env.REACT_APP_SOCIAL_AUTH_SERVER_URL || 'https://localhost:8096';
